import { Button } from '@/components/ui/button';
import { t } from 'i18next';
import { CalendarClock, X } from 'lucide-react';
import TableToolBar from './TableToolBar';
import useReservationsTable from '@/hooks/table/useReservationsTable';
import { useState } from 'react';
import ErrorMessage from '@/components/common/error-message/ErrorMessage';
import { GenericTable } from '@/components/common/tables/common/generic-table/GenericTable';
import AlertModal from '@/components/common/modals/alert-modal/AlertModal';
import ReprogrameDateModal from '@/components/common/modals/reprograme-date-modal/ReprogrameDateModal';

export function ReservationsTable<TData, TValue>() {
  const [showCancelReservation, setShowCancelReservation] = useState(false);
  const {
    table,
    filtering,
    setFiltering,
    reservationsChecked,
    reservationSelected,
    handleCancelReservation,
    handleReschedule,
    showReprogrameModal,
    setShowReprogrameModal,
    isFetching,
    isLoading,
    isError
  } = useReservationsTable();

  if (isError) {
    return <ErrorMessage />;
  }

  return (
    <>
      <TableToolBar
        table={table}
        filtering={filtering}
        setFiltering={setFiltering}
        isFetching={isFetching}
      />
      {(table.getIsAllPageRowsSelected() || table.getIsSomeRowsSelected()) && (
        <div className="flex items-center justify-start gap-2">
          <Button
            variant={'ghost'}
            onClick={() => {
              setShowCancelReservation(true);
            }}
          >
            <X color="#EF4444" />
          </Button>
          {reservationsChecked.length === 1 ? (
            <Button
              variant={'ghost'}
              onClick={() => {
                setShowReprogrameModal(true);
              }}
            >
              <CalendarClock color="#A855F7" />
            </Button>
          ) : null}
        </div>
      )}

      <GenericTable table={table} isLoading={isLoading} />

      <AlertModal
        open={showCancelReservation}
        onOpenChange={setShowCancelReservation}
        title={t('modals.alert.title')}
        description={t('modals.alert.descriptionCancelReservation')}
        cancelText={t('modals.alert.no')}
        acceptText={t('modals.alert.yes')}
        onAccept={() => handleCancelReservation()}
      />
      {showReprogrameModal ? (
        <ReprogrameDateModal
          open={showReprogrameModal}
          onOpenChange={setShowReprogrameModal}
          onSave={(date) => handleReschedule(date)}
          serviceId={reservationSelected.service?.id}
          participants={reservationSelected.consumers.length}
          startTime={Number(reservationSelected.startTime)}
        />
      ) : null}
    </>
  );
}
